var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Pane, MenuSection, MessageBanner, Modal, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useOkapiKy, useCallout } from "@folio/stripes/core";
import { useMutation, useQueryClient } from "react-query";
import TableComponent from "../../components/TableComponent";
import NavComponent from "../../components/NavComponent";
import ProductNumberDetail from "./ProductNumberDetail";
import { ProductNumberAssignTitleModal } from "./ProductNumberAssignTitleModal";
import { ProductNumberFilters } from "../../components/ProductNumberFilters";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { RecekSelect, RecekTextArea } from "../../components/inputs";
import { createStripesSource } from "../../utils/createStripesSource";
import { useProductNumberFilters } from "../../hooks/useProductNumberFilters";
import { useProductNumberData } from "../../hooks/useProductNumberData";
import { useProductNumberTable } from "../../hooks/useProductNumberTable";
import { useProductNumberActions } from "../../hooks/useProductNumberActions";
import { usePermissions } from "../../hooks/usePermissions";
import { useApiErrorMessageId } from "../../hooks/useApiErrorMessageId";
import { usePageSize } from "../../hooks/usePageSize";
import { useTableSort } from "../../hooks/useTableSort";
import { COLUMN_LAYOUT_KEYS } from "../../utils/constants";
import { getErrorCode } from "../../utils/getErrorCode";
import { isRetiredProductNumber, resolveBlockActionErrorMessageId, } from "../../utils/blockReason";
import { blockProductNumber, unblockProductNumber, } from "../../api/productNumberService";
import { ProductNumberBlockRequestBlockReasonEnum, ProductNumberBlockReasonEnum, } from "../../types/Api";
import { CurrentUserLoadErrorBanner } from "../../components/CurrentUserLoadErrorBanner";
export var ProductNumberList = function () {
    var history = useHistory();
    var formatMessage = useIntl().formatMessage;
    var ky = useOkapiKy();
    var callout = useCallout();
    var queryClient = useQueryClient();
    var _a = useState(true), filterPaneIsVisible = _a[0], setFilterPaneIsVisible = _a[1];
    var _b = usePermissions(), isAgencyWorker = _b.isAgencyWorker, canBlockProductNumber = _b.canBlockProductNumber;
    var _c = useState(false), isBlockModalOpen = _c[0], setIsBlockModalOpen = _c[1];
    var _d = useState(false), isAssignTitleModalOpen = _d[0], setIsAssignTitleModalOpen = _d[1];
    var _e = useState(""), blockReason = _e[0], setBlockReason = _e[1];
    var _f = useState(""), blockComment = _f[0], setBlockComment = _f[1];
    var filtersHook = useProductNumberFilters();
    var _g = usePageSize(), pageSize = _g.pageSize, createPageSizeHandler = _g.createPageSizeHandler;
    var _h = useTableSort(), sort = _h.sort, handleHeaderClick = _h.handleHeaderClick;
    var dataHook = useProductNumberData(filtersHook.filters, pageSize, sort, filtersHook.filtersReady);
    // e.g. -92 when a public-only user's search hits agency-internal data (DB-837)
    var loadErrorMessageId = useApiErrorMessageId(dataHook.error, "ui-br-agency.product-number.list.loadError");
    var actionsHook = useProductNumberActions();
    var tableColumns = useProductNumberTable(actionsHook.handleRowClick).tableColumns;
    var toggleFilterPane = function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); };
    var handlePageSizeChange = createPageSizeHandler(dataHook.fetchMoreData);
    var handleCreate = function () {
        history.push("/bragency/product-numbers/create");
    };
    var handleSortHeaderClick = function (columnId) {
        dataHook.resetPageOffset();
        handleHeaderClick(columnId);
    };
    var handleApplyFilters = function () {
        // Enter submits the filter form even while Apply is disabled.
        if (filtersHook.hasInvalidDateRange)
            return;
        dataHook.resetPageOffset();
        filtersHook.handleApplyFilters();
    };
    var handleClearFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleClearFilters();
    };
    var showBlockActionError = function (error) { return __awaiter(void 0, void 0, void 0, function () {
        var code;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getErrorCode(error)];
                case 1:
                    code = _a.sent();
                    callout === null || callout === void 0 ? void 0 : callout.sendCallout({
                        type: "error",
                        message: formatMessage({ id: resolveBlockActionErrorMessageId(code) }),
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var blockMutation = useMutation(function (_a) {
        var id = _a.id, data = _a.data;
        return blockProductNumber(ky, id, data);
    }, {
        onSuccess: function () {
            var _a;
            queryClient.invalidateQueries(["productNumbers"]);
            queryClient.invalidateQueries([
                "productNumber",
                (_a = actionsHook.selectedProductNumber) === null || _a === void 0 ? void 0 : _a.id,
            ]);
            dataHook.refetch();
            setIsBlockModalOpen(false);
            setBlockReason("");
            setBlockComment("");
        },
        onError: function (error) {
            setIsBlockModalOpen(false);
            showBlockActionError(error);
        },
    });
    var unblockMutation = useMutation(function (id) { return unblockProductNumber(ky, id); }, {
        onSuccess: function () {
            var _a;
            queryClient.invalidateQueries(["productNumbers"]);
            queryClient.invalidateQueries([
                "productNumber",
                (_a = actionsHook.selectedProductNumber) === null || _a === void 0 ? void 0 : _a.id,
            ]);
            dataHook.refetch();
        },
        onError: function (error) {
            showBlockActionError(error);
        },
    });
    var handleBlockToggle = function () {
        if (!actionsHook.selectedProductNumber)
            return;
        if (actionsHook.selectedProductNumber.blocked) {
            unblockMutation.mutate(actionsHook.selectedProductNumber.id);
        }
        else {
            setIsBlockModalOpen(true);
        }
    };
    var handleBlockConfirm = function () {
        if (!actionsHook.selectedProductNumber || !blockReason)
            return;
        blockMutation.mutate({
            id: actionsHook.selectedProductNumber.id,
            data: {
                blockReason: blockReason,
                blockComment: blockComment || undefined,
            },
        });
    };
    var selectedNumber = actionsHook.selectedProductNumber;
    // A number retired on product delete stays blocked forever — no unblock,
    // re-block or legalization is offered (the backend rejects them too).
    var isRetired = isRetiredProductNumber(selectedNumber);
    // A title can be attached to legalize a blocked number only when it is blocked
    // for an eligible reason (numbers a publisher used before the registry existed).
    // UNAUTHORIZED_USE is deliberately excluded — the backend rejects it too.
    var canAssignTitleToNumber = isAgencyWorker &&
        !!(selectedNumber === null || selectedNumber === void 0 ? void 0 : selectedNumber.blocked) &&
        ((selectedNumber === null || selectedNumber === void 0 ? void 0 : selectedNumber.blockReason) ===
            ProductNumberBlockReasonEnum.PRESUMED_PUBLISHED ||
            (selectedNumber === null || selectedNumber === void 0 ? void 0 : selectedNumber.blockReason) ===
                ProductNumberBlockReasonEnum.USED_BEFORE_REGISTRY);
    var handleAssignTitleSuccess = function () {
        queryClient.invalidateQueries(["productNumbers"]);
        queryClient.invalidateQueries(["productNumber", selectedNumber === null || selectedNumber === void 0 ? void 0 : selectedNumber.id]);
        dataHook.refetch();
        setIsAssignTitleModalOpen(false);
        callout === null || callout === void 0 ? void 0 : callout.sendCallout({
            type: "success",
            message: formatMessage({
                id: "ui-br-agency.product-number.assignTitle.success",
            }),
        });
    };
    var handleAssignTitleError = function (message) {
        callout === null || callout === void 0 ? void 0 : callout.sendCallout({ type: "error", message: message });
    };
    var source = createStripesSource({
        ky: null,
        data: dataHook.productNumbersData,
        totalRecords: dataHook.totalRecords,
        isLoading: dataHook.isLoading || dataHook.isWaitingForFilters,
        isError: dataHook.isError,
        isLoaded: dataHook.isFetched,
        fetchMore: function () {
            return dataHook.fetchMoreData(dataHook.pageOffset + dataHook.pageSize);
        },
        failureMessage: formatMessage({ id: loadErrorMessageId }),
    });
    // Never show "0 records" while the list is still loading or after it failed to load:
    // the whole-registry search can take a moment, and a zero count reads as an empty registry.
    var loadStatus = (function () {
        if (dataHook.isFetching || dataHook.isWaitingForFilters) {
            return formatMessage({ id: "ui-br-agency.product-number.list.loading" });
        }
        if (dataHook.isError) {
            return undefined;
        }
        return formatMessage({ id: "ui-br-agency.table.subtitle.records-found" }, { count: dataHook.totalRecords });
    })();
    return (React.createElement(RecekPaneSet, null,
        filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-agency.pane.title.navigation",
            }) },
            React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                React.createElement(NavComponent, null),
                React.createElement(Button, { buttonStyle: "none", id: "clickable-reset-all", disabled: !filtersHook.isAnyFilterActive(), marginBottom0: true, onClick: handleClearFilters },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.resetAll" })),
                React.createElement(ProductNumberFilters, { temporaryPublisherFilter: filtersHook.temporaryPublisherFilter, temporaryPublisherPrefixFilter: filtersHook.temporaryPublisherPrefixFilter, temporaryProductNumberFilter: filtersHook.temporaryProductNumberFilter, temporaryBlockedFilter: filtersHook.temporaryBlockedFilter, temporaryDateRangeFilters: filtersHook.temporaryDateRangeFilters, onDateRangeFilterChange: filtersHook.setTemporaryDateRangeFilter, hasInvalidDateRange: filtersHook.hasInvalidDateRange, dateInputs: filtersHook.dateInputs, publisherSearchQuery: filtersHook.publisherSearchQuery, selectedPublisherData: filtersHook.selectedPublisherData, selectedPublisherLoading: filtersHook.selectedPublisherLoading, publisherPrefixesData: filtersHook.publisherPrefixesData, publisherPrefixesLoading: filtersHook.publisherPrefixesLoading, onPublisherFilterChange: filtersHook.handlePublisherSelection, onPublisherPrefixFilterChange: filtersHook.handlePublisherPrefixSelection, onProductNumberFilterChange: filtersHook.setTemporaryProductNumberFilter, onBlockedFilterChange: filtersHook.setTemporaryBlockedFilter, onPublisherSearchInput: filtersHook.handlePublisherSearchInput, onApplyFilters: handleApplyFilters })))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-agency.product-number.table.title",
            }), paneSub: loadStatus, actionMenu: isAgencyWorker
                ? function (_a) {
                    var onToggle = _a.onToggle;
                    return (React.createElement(MenuSection, { label: "Akce", id: "actions-menu" },
                        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                onToggle();
                                handleCreate();
                            } },
                            React.createElement(FormattedMessage, { id: "ui-br-agency.button.create" })),
                        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                onToggle();
                                history.push("/bragency/product-numbers/block-range");
                            } },
                            React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.button.blockRange" }))));
                }
                : undefined },
            dataHook.isError && !dataHook.isFetching && (React.createElement(MessageBanner, { type: "error" },
                React.createElement(FormattedMessage, { id: loadErrorMessageId }),
                " ",
                React.createElement(Button, { buttonStyle: "default", marginBottom0: true, onClick: function () { return dataHook.refetch(); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.list.retry" })))),
            React.createElement(CurrentUserLoadErrorBanner, { show: filtersHook.currentUserLoadFailed }),
            React.createElement(TableComponent, { data: dataHook.productNumbersData, columns: tableColumns, pageSize: pageSize, onPageSizeChange: handlePageSizeChange, totalCount: dataHook.totalRecords, pagingOffset: dataHook.pageOffset, onNeedMoreData: function (offset) { return dataHook.fetchMoreData(offset); }, searchTerm: "", filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane, source: source, sortedColumn: sort.column, sortDirection: sort.column ? sort.direction : undefined, onHeaderClick: handleSortHeaderClick, layoutKey: COLUMN_LAYOUT_KEYS.PRODUCT_NUMBERS })),
        actionsHook.selectedProductNumber && (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: formatMessage({
                id: "ui-br-agency.product-number.detail.pane.title",
            }), onClose: actionsHook.handleCloseDetail, dismissible: true, actionMenu: isRetired || (!canBlockProductNumber && !canAssignTitleToNumber)
                ? undefined
                : function (_a) {
                    var _b;
                    var onToggle = _a.onToggle;
                    return (React.createElement(MenuSection, { label: "Akce", id: "actions-menu" },
                        canBlockProductNumber && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: handleBlockToggle, fullWidth: true },
                            React.createElement(FormattedMessage, { id: ((_b = actionsHook.selectedProductNumber) === null || _b === void 0 ? void 0 : _b.blocked)
                                    ? "ui-br-agency.product-number.button.unblock"
                                    : "ui-br-agency.product-number.button.block" }))),
                        canAssignTitleToNumber && (React.createElement(Button, { buttonStyle: "dropdownItem", fullWidth: true, onClick: function () {
                                onToggle();
                                setIsAssignTitleModalOpen(true);
                            } },
                            React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.button.assignTitle" })))));
                } },
            React.createElement(ProductNumberDetail, { productNumber: actionsHook.selectedProductNumber }))),
        React.createElement(Modal, { open: isBlockModalOpen, label: formatMessage({
                id: "ui-br-agency.product-number.block.modal.title",
            }), footer: React.createElement(React.Fragment, null,
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBlockConfirm },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.confirm" })),
                React.createElement(Button, { buttonStyle: "default", onClick: function () {
                        setIsBlockModalOpen(false);
                        setBlockReason("");
                        setBlockComment("");
                    } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" }))) },
            React.createElement(RecekSelect, { labelId: "ui-br-agency.product-number.field.label.blockReason", value: blockReason, onChange: function (e) {
                    return setBlockReason(e.target.value);
                }, required: true },
                React.createElement("option", { value: "" }, formatMessage({
                    id: "ui-br-agency.product-number.field.placeholder.blockReason",
                })),
                React.createElement("option", { value: ProductNumberBlockRequestBlockReasonEnum.UNAUTHORIZED_USE }, formatMessage({
                    id: "ui-br-agency.product-number.blockReason.unauthorizedUse",
                })),
                React.createElement("option", { value: ProductNumberBlockRequestBlockReasonEnum.PRESUMED_PUBLISHED }, formatMessage({
                    id: "ui-br-agency.product-number.blockReason.presumedPublished",
                }))),
            React.createElement(RecekTextArea, { labelId: "ui-br-agency.product-number.field.label.blockComment", value: blockComment, onChange: function (e) {
                    return setBlockComment(e.target.value);
                } })),
        isAssignTitleModalOpen && selectedNumber && (React.createElement(ProductNumberAssignTitleModal, { productNumber: selectedNumber, onClose: function () { return setIsAssignTitleModalOpen(false); }, onAssigned: handleAssignTitleSuccess, onError: handleAssignTitleError }))));
};
